import React from 'react';

const SkeletonIdeaCard = () => {
    return (
        <div className="bg-surface/40 backdrop-blur-sm border border-white/5 rounded-2xl p-6 h-full flex flex-col animate-pulse">
            {/* Header Skeleton */}
            <div className="flex items-start justify-between mb-4">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-white/5"></div>
                    <div>
                        <div className="h-4 w-24 bg-white/5 rounded mb-2"></div>
                        <div className="h-3 w-16 bg-white/5 rounded"></div>
                    </div>
                </div>
            </div>

            {/* Title Skeleton */}
            <div className="h-6 w-3/4 bg-white/5 rounded mb-4"></div>

            {/* Description Skeleton */}
            <div className="space-y-2 mb-6 flex-grow">
                <div className="h-4 w-full bg-white/5 rounded"></div>
                <div className="h-4 w-5/6 bg-white/5 rounded"></div>
                <div className="h-4 w-4/6 bg-white/5 rounded"></div>
            </div>

            {/* Footer Skeleton */}
            <div className="mt-auto pt-4 border-t border-white/5 flex justify-between items-center">
                <div className="h-4 w-12 bg-white/5 rounded"></div>
                <div className="h-4 w-20 bg-white/5 rounded"></div>
            </div>
        </div>
    );
};

export default SkeletonIdeaCard;
